import { CONTROLLED_PROPS } from "./constants.js";
function validateMaxLength(props) {
    if (props.maxLength && props.mask) console.warn("react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.");
}
function validateChildren(props, inputElement) {
    const conflictProps = CONTROLLED_PROPS.filter((propId)=>null != inputElement.props[propId] && inputElement.props[propId] !== props[propId]);
    if (conflictProps.length) console.error(`react-input-mask: the following props should be passed to the InputMask component, not to children: ${conflictProps.join(',')}`);
}
export { validateChildren, validateMaxLength };
